"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _dealerLocator = _interopRequireDefault(require("../styles/dealer-locator.css"));
var Marker = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Marker, _React$Component);
  function Marker() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Marker.prototype;
  _proto.getMarkerStyle = function getMarkerStyle() {
    var _this$props = this.props,
      hoverable = _this$props.hoverable,
      active = _this$props.active;
    return hoverable || active ? _dealerLocator["default"].highlightedPin : '';
  };
  _proto.render = function render() {
    var label = this.props.label;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLocator["default"].markerWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: this.getMarkerStyle()
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLocator["default"].pin,
      "aria-hidden": true
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _dealerLocator["default"].label
    }, label))));
  };
  return Marker;
}(_react["default"].Component);
exports["default"] = Marker;
Marker.defaultProps = {
  hoverable: false,
  active: false
};